// Static content & shared data for Temple of Kulture
// All client-side content lives here so pages stay clean.

// Primary desktop nav — 6 most-converting destinations.
// 'More' dropdown lives separately (NAV_MORE below).
// Primary top-nav. Identity-led: Home → Experiences → For You ▾ → XR Studio → What's On → Corporate → More.
export const NAV = [
  { label: "Home", to: "/" },
  { label: "Experiences", to: "/experiences" },
  { label: "XR Studio", to: "/xr-studio" },
  { label: "What's On", to: "/whats-on" },
  { label: "Corporate", to: "/corporate" },
];

// Audience-first "For You" dropdown — sits between Experiences and XR Studio in the header.
export const NAV_FOR_YOU = [
  { label: "For Families", to: "/family" },
  { label: "For Schools", to: "/schools" },
  { label: "For Young People 16-25", to: "/youth" },
  { label: "For Communities", to: "/community" },
  { label: "For Artists", to: "/xr-studio" },
  { label: "For Organisations", to: "/corporate" },
];

// 'More' dropdown — utility links only (Projects, Festivals, Impact, Press, Policies).
export const NAV_MORE = [
  { label: "Projects", to: "/projects" },
  { label: "Festivals", to: "/festivals" },
  { label: "Community", to: "/community" },
  { label: "Impact", to: "/impact" },
  { label: "Partners", to: "/impact#partners" },
  { label: "Policies", to: "/policies" },
];

export const TOK_LOGO =
  "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/avoln801_febedab8-c6eb-4cd8-8bb2-343d8ef3a208.png";

// Real TOK assets — uploaded by client + scraped from live templeofkulture.co.uk
export const TOK_ASSETS = {
  // Brand
  logoCircle:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/avoln801_febedab8-c6eb-4cd8-8bb2-343d8ef3a208.png",
  logoSquare:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/2g8ewztc_Logo-TOK%27.jpg",

  // Newly uploaded — primary identity-critical
  homePyramids:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/291scsud_home%20page%20.png",
  rebirthMother:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/msrisfk4_rebirth%20of%20a%20mother%20.png",
  outcastShow:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/10n17o33_The%20outcast%20immersive%20show%20.png",
  whoWeAre:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/2clkxdjm_Who%20We%20Are%20%281%29.png",
  williamCuffay:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/vrqrahrs_William%20cuffay%20.png",

  // Windrush Immersive Experience — official campaign assets
  windrushIllustration:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/qx7o4gso_0.%20Illustration%20-%20with%20logo%20-%20centred%20.png",
  windrushSpaceTop:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/2gms9hdo_0.%20Illustration%20-%20with%20logo%20-%20space%20at%20top%20%20.png",
  windrushFacebook:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/4ggjdpic_4.%20Facebook%20Page%20Cover%20%28820x312px%29.png",
  windrushBanner:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/ghr76yvz_6.%20Website%20Header%20Banner%20%281920x1080px%20or%201920x600px%29.png",

  // First batch (still in use)
  communityVR:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/w57wezjh_Screenshot_20250518-202442.png",
  outcastCity:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/0k0nbnph_The%20outcast%20immersive%20show%20.png",
  vrFloor:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/actdb599_yellow%20modern%20fitness%20and%20gym%20social%20media%20facebook%20cover%20%281%29.png",
  academyVR:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/ox4b2yv8_yellow%20modern%20fitness%20and%20gym%20social%20media%20facebook%20cover%20%282%29.png",
  vrHands:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/tq0r76ia_yellow%20modern%20fitness%20and%20gym%20social%20media%20facebook%20cover%20%283%29.png",
  windrushDancers:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/ifdsgck5_yellow%20modern%20fitness%20and%20gym%20social%20media%20facebook%20cover%20%284%29.png",
  immersiveSilhouettes:
    "https://customer-assets.emergentagent.com/job_kulture-ecosystem/artifacts/g2gu70o7_yellow%20modern%20fitness%20and%20gym%20social%20media%20facebook%20cover%20%285%29.png",

  // Live Squarespace CDN — real TOK production photography
  sqDance:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/b618c15f-2c3d-4273-97ed-79aded3927e5/dance+tok.jpg",
  sqKulturalTheatre:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/1e64a61d-8d1d-4efa-997e-ec0c86d3c50a/kultural+theatre+at+TOK.jpg",
  sqEnterDimension:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/b63ac549-afd9-47f8-aeda-eb948c679ba1/Enter+a+new+dimension-+temple+of+Kulture.jpg",
  sqVrProjects:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/3d26ce77-fe23-44b5-aa81-1f5eaa07797e/VR+projects+at+temple+of+Kulture.jpg",
  sqXrLed:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/0d952edf-bd60-4e56-bf5b-de19a39cb278/xR+LED+screen+Temple+Of+Kulture.png",
  sqActing:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/bb3784a3-6433-4d52-9935-6fd873e34fe2/Acting+workshops+Temple+of+Kulture.png",
  sqLedScreenXr:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/327c8ccd-5198-44e9-9826-60fc04b23b45/LED+screen+XR+technology+Temple+Of+Kulture.jpg",
  sqLiveTheatre:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/6e506032-17b9-461d-b626-aa0536616f30/Live+theatre+Temple+Of+Kulture.png",
  sqTokVR:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/9f871461-8e91-4f9e-aee2-9c587ed3a87b/TOK+VR+experience.png",
  sqFestival:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/38aa7a5a-74d7-4fa8-bd4b-07769baad146/Temple+of+Kulture+festival.jpg",
  sqXrImmersive:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/b3c11ffe-4cd7-4321-b867-3d4d37742976/Temple+Of+Kulture+XR+immersive+Theatre.png",
  sqPlaywriting:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/625697a5-4a98-443d-855f-2275244e5311/Playwriting+Temple+of+Kulture.png",
  sqBoraBora:
    "https://images.squarespace-cdn.com/content/v1/64e8ff29ab185008d3e55aa4/b57bea90-d89b-4f20-8fed-18d949d88b97/Bora+Bora+mermaid+tok.png",
};

export const HERO_IMG = TOK_ASSETS.homePyramids;

// AI-generated bespoke brand imagery — served from backend static mount.
// Each section gets its own cinematic mood, palette and composition (no repetition).
const AI = (slug) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/static/ai/${slug}.png`;

// To regenerate an AI image, run:
//   cd /app/backend && python scripts/generate_brand_imagery.py <slug>
export const IMG = {
  hero: TOK_ASSETS.homePyramids,
  heroPortal: AI("hero_portal"),
  levelUp: AI("level_up"),
  windrushEvergreen: AI("windrush_evergreen"),
  immersiveNights: AI("immersive_nights"),
  xrTheatre: AI("xr_theatre"),
  wellness: AI("wellness"),
  ubuntuRetreat: AI("ubuntu_retreat"),
  playground: AI("interactive_playground"),
  // Legacy keys retained for surfaces not yet rebriefed — used sparingly.
  academy: TOK_ASSETS.sqActing,
  xr: TOK_ASSETS.sqTokVR,
  festivals: TOK_ASSETS.sqFestival,
  corporate: TOK_ASSETS.sqLedScreenXr,
  dance1: TOK_ASSETS.sqDance,
  dance2: TOK_ASSETS.windrushDancers,
  vr: TOK_ASSETS.sqXrLed,
  redDancer: TOK_ASSETS.outcastShow,
};

// ----- Live TOK voice/copy (preserved verbatim from templeofkulture.co.uk) -----
export const TOK_VOICE = {
  pageTitle: "The kingdom of immersive theatre & untold xR stories",
  heroEyebrow: "An immersive cultural ecosystem",
  heroHeadline: "ENTER A NEW DIMENSION.",
  heroSubtagline:
    "The kingdom of immersive theatre & untold xR stories.",
  heroCta: "JOIN THE TEMPLE",
  missionHeading:
    "WE'RE PROVIDING HIGH QUALITY IMMERSIVE THEATRE DEDICATED TO TELLING KULTURAL UNHEARD STORIES.",
  missionBody1:
    "Temple of Kulture is all about giving a voice to the global majority through immersive experiences and extended reality technology.",
  missionBody2:
    "Our mission? To break down barriers, spark change, and nurture creativity by sharing stories that need to be heard. Our programs offer both virtual and live workshops and courses aimed at helping you achieve your Performing and Visual Arts goals.",
  templeActivities: [
    "xR (AR/VR/MR) Workshops",
    "Street & Kultural Dances Lab",
    "Virtual Production Workshops",
    "Playwright Lab",
    "Acting Courses",
    "Directing Workshops",
    "Artists Development Programme",
    "Physical Theatre Workshops",
    "Sound Design Workshops",
    "TOK Hip Hop Festival",
    "Interactive Playground",
    "XR Walking Theatre",
  ],
  locations: ["MEDWAY", "LONDON", "KENT"],
  donationHeading: "Make a donation.",
  donationBody:
    "Empower the unheard and uplift those carrying untold stories. Your contribution, no matter the size, fuels our mission to share immersive theatre experiences with global majority communities. Join us in making a meaningful impact today.",
  quote: "The role of the artist is to awaken the village.",
  quoteBy: "Temple of Kulture",
};

// Immersive show roster — TOK's signature productions.
// `focal` is the object-position string applied to the card image so the
// subject is preserved across the 4:3 image zone on every card.
// Format: "<x%> <y%>" (or "center"). Tuned per source image.
export const TOK_SHOWS = [
  {
    id: "windrush-immersive-experience",
    title: "The Windrush Immersive Experience",
    eyebrow: "Featured · HYPHA Studio",
    desc: "A journey through memory, movement and legacy — TOK's headline immersive experience.",
    image: TOK_ASSETS.windrushBanner,
    focal: "50% 35%",
    href: "/shows/windrush-immersive-experience",
    external: false,
  },
  {
    id: "rebirth-of-a-mother",
    title: "Rebirth of a Mother",
    eyebrow: "Immersive Show",
    desc: "A silhouette story of grief, lineage and the women who carry whole worlds inside them.",
    image: TOK_ASSETS.rebirthMother,
    focal: "30% 38%",
    href: "/shows/rebirth-of-a-mother",
    external: false,
  },
  {
    id: "william-cuffay",
    title: "William Cuffay",
    eyebrow: "Living History",
    desc: "Revolutionary Chartist (1788–1870) — a Black British story finally told as immersive theatre.",
    image: TOK_ASSETS.williamCuffay,
    // Source has the subject at ~68% horizontal / ~44% vertical and a baked-in
    // "WILLIAM CUFFAY" title in the lower band. Cropping right-of-centre keeps
    // his face high; the card's text strip then covers the baked title.
    focal: "68% 30%",
    href: "/shows/william-cuffay",
    external: false,
  },
  {
    id: "the-outcasts",
    title: "The Outcasts",
    eyebrow: "Immersive Show",
    desc: "An XR theatre piece set in a neon-soaked city — diaspora identity in a world that refuses to see it.",
    image: TOK_ASSETS.outcastShow,
    focal: "70% 45%",
    href: "https://www.templeofkulture.co.uk/the-outcasts",
    external: true,
  },
  {
    id: "buro-buro-mermaid",
    title: "Buro Buro Mermaid",
    eyebrow: "Immersive Show",
    desc: "A folklore-led XR piece weaving island mythology, dance and projection into a single performance.",
    image: TOK_ASSETS.sqBoraBora,
    focal: "50% 35%",
    href: "https://www.templeofkulture.co.uk/buro-buro-mermaid",
    external: true,
  },
];

export const PILLARS = [
  {
    label: "Experiences",
    title: "Immersive nights & social rituals",
    desc: "Afro Anime Socials, Immersive Afro Brunch, film nights, wellness, exhibitions.",
    to: "/experiences",
    image: IMG.immersiveNights,
    focal: "50% 40%",
  },
  {
    label: "Level Up",
    title: "Where 16–25 creatives become world-builders",
    desc: "Immersive arts, XR, AI storytelling, filmmaking, music & employability — with pathways into University of Kent, Rose Bruford and the creative industries.",
    to: "/level-up-xr",
    image: IMG.levelUp,
    focal: "50% 40%",
  },
  {
    label: "XR Studio",
    title: "Worlds you can walk inside",
    desc: "Kulture Lab, XR walking theatre, projection mapping, AR/VR & AI storytelling.",
    to: "/xr-studio",
    image: IMG.xrTheatre,
    focal: "50% 40%",
  },
  {
    label: "Corporate",
    title: "Immersive experiences for organisations",
    desc: "Team building, gaming socials, bespoke immersive productions for brands.",
    to: "/corporate",
    image: IMG.corporate,
    focal: "50% 45%",
  },
  {
    label: "Festivals",
    title: "TOK Hip Hop & TOK XR Festivals",
    desc: "Two flagship festivals celebrating culture, sound and immersive technology.",
    to: "/festivals",
    image: IMG.festivals,
    focal: "50% 45%",
  },
  {
    label: "Community",
    title: "Roots, diaspora & futures",
    desc: "Windrush, Kulture Kraft Market, heritage storytelling and global majority celebration.",
    to: "/community",
    image: IMG.dance2,
    focal: "50% 35%",
  },
];

export const EXPERIENCES = [
  {
    title: "Afro Anime Social",
    tagline: "Cosplay × diaspora × DJ sets",
    desc: "Our signature after-dark social fusing anime worlds, Afro-futurism and immersive projection.",
    image: IMG.immersiveNights,
    href: "/whats-on?filter=nightlife",
  },
  {
    title: "Raise Your Game Up Social",
    tagline: "Gaming culture, levelled up",
    desc: "Tournaments, immersive arena visuals and curated sound for the gaming generation.",
    image: IMG.playground,
    href: "/whats-on?filter=nightlife",
  },
  {
    title: "Immersive Afro Brunch",
    tagline: "A cinematic feast",
    desc: "Diaspora flavours, live performance and floor-to-ceiling projection storytelling.",
    image: IMG.dance2,
    href: "/whats-on?filter=nightlife",
  },
  {
    title: "Immersive Film Nights",
    tagline: "Cinema as a world to enter",
    desc: "360° screenings with surround projection, scent design and live discussion.",
    image: IMG.xrTheatre,
    href: "/whats-on?filter=nightlife",
  },
  {
    title: "Immersive Wellness",
    tagline: "Stillness as a frequency",
    desc: "Sound bath, breath and projection rituals rooted in diaspora wisdom.",
    image: IMG.wellness,
    href: "/ubuntu-retreat",
  },
  {
    title: "Exhibitions",
    tagline: "Living artworks",
    desc: "Rotating immersive exhibitions from global majority artists and collectives.",
    image: IMG.windrushEvergreen,
    href: "/community",
  },
  {
    title: "TOK Winter Experience",
    tagline: "A season-long world",
    desc: "Projection forests, light rituals and storytelling chambers across winter.",
    image: IMG.heroPortal,
    href: "/whats-on?filter=nightlife",
  },
];

export const ACADEMY = [
  {
    title: "Create My Own Magic",
    age: "Ages 7–11",
    desc: "Imagination, performance and identity through play.",
    image: IMG.academy,
  },
  {
    title: "Future Sound Lab",
    age: "Ages 12–17",
    desc: "Production, beat-making and sound design for emerging young producers.",
    image: IMG.dance1,
  },
  {
    title: "Scribble Squad",
    age: "Ages 6–10",
    desc: "Story drawing, comics and visual world-building.",
    image: IMG.dance2,
  },
  {
    title: "Mini Musicians",
    age: "Ages 3–6",
    desc: "First instruments, rhythm and joyful sound discovery.",
    image: IMG.vr,
  },
  {
    title: "Drama & Acting",
    age: "Ages 8+",
    desc: "Voice, stage and screen craft with global majority practitioners.",
    image: IMG.redDancer,
  },
  {
    title: "Singing & Songwriting",
    age: "Ages 10+",
    desc: "Write, record and perform your own songs in our studio.",
    image: IMG.dance1,
  },
  {
    title: "Filmmaking",
    age: "Ages 12+",
    desc: "From concept to camera to cut — make your first short film.",
    image: IMG.vr,
  },
  {
    title: "AI Creation Workshops",
    age: "All ages",
    desc: "Hands-on AI image, story and sound tools for young creators & educators.",
    image: IMG.academy,
  },
  {
    title: "Immersive Storytelling",
    age: "Teens & adults",
    desc: "World-building across XR, projection and sound.",
    image: IMG.xr,
  },
];

export const XR_OFFERINGS = [
  {
    title: "Kulture Lab",
    desc: "Our R&D and production studio for immersive cultural worlds.",
    image: IMG.xrTheatre,
    href: "/kulture-lab",
  },
  {
    title: "XR Walking Theatre",
    desc: "Audiences walk inside live stories — projection, sound and performance fused.",
    image: IMG.heroPortal,
    // XR walking theatre productions appear in the live calendar under the XR filter.
    href: "/whats-on?filter=xr",
  },
  {
    title: "Projection Mapping",
    desc: "We turn rooms, buildings and bodies into living canvases.",
    image: IMG.corporate,
    // Commissionable services route to the Corporate enquiry funnel.
    href: "/corporate",
  },
  {
    title: "AI Storytelling",
    desc: "Story engines, generative visuals and adaptive narratives.",
    image: IMG.levelUp,
    href: "/corporate",
  },
  {
    title: "AR Experiences",
    desc: "Augmented layers for festivals, brands and cultural spaces.",
    image: IMG.vr,
    href: "/corporate",
  },
  {
    title: "VR Experiences",
    desc: "Standalone VR pieces and headset-led cultural journeys.",
    image: IMG.dance1,
    href: "/corporate",
  },
  {
    title: "Immersive Digital Playground",
    desc: "Movement-led interactive games for all ages.",
    image: IMG.playground,
    // The Interactive Playground page is the consumer-facing version of this offer.
    href: "/interactive-playground",
  },
  {
    title: "Interactive Movement & Educational Games",
    desc: "Embodied learning experiences — schools, museums and festivals.",
    image: IMG.wellness,
    href: "/corporate",
  },
];

export const CORPORATE_OFFERINGS = [
  "Immersive team building",
  "Gaming socials",
  "Immersive brunches",
  "Staff wellbeing experiences",
  "Immersive storytelling",
  "Bespoke immersive productions",
  "AI storytelling & media experiences",
];

export const FESTIVALS = [
  {
    title: "TOK Hip Hop Festival",
    when: "Summer 2026",
    desc: "A full-day celebration of UK and diasporic hip hop — immersive stages, ciphers, food, art.",
    image: IMG.immersiveNights,
  },
  {
    title: "TOK XR Festival",
    when: "Autumn 2026",
    desc: "A weekend of XR theatre, projection mapping, AI storytelling and immersive worlds.",
    image: IMG.xrTheatre,
  },
];

export const COMMUNITY = [
  {
    title: "Windrush Experiences",
    desc: "Living memory through projection, oral history and live performance.",
    image: IMG.windrushEvergreen,
    href: "/shows/windrush-immersive-experience",
  },
  {
    title: "Kulture Kraft Market",
    desc: "A monthly market spotlighting global majority makers and food creators.",
    image: IMG.redDancer,
    // Market dates live in What's On under the workshop filter.
    href: "/whats-on?filter=workshop",
  },
  {
    title: "Community Programmes",
    desc: "Free and pay-what-you-can sessions for local young people and families.",
    image: IMG.playground,
    // Open invitation to register interest in upcoming community sessions.
    href: "/join",
  },
  {
    title: "Cultural Storytelling",
    desc: "Diaspora narratives told through immersive technology and craft.",
    image: IMG.heroPortal,
    href: "/xr-studio",
  },
  {
    title: "Global Majority Celebration",
    desc: "We centre, commission and platform global majority artists across everything we do.",
    image: IMG.immersiveNights,
    // Impact page documents this commitment with data + partner network.
    href: "/impact",
  },
  {
    title: "Heritage & Future Identities",
    desc: "Island cultures, African diaspora, Caribbean heritage, migration & Afro-futurism.",
    image: IMG.wellness,
    // The Windrush show is the flagship work in this stream.
    href: "/shows/windrush-immersive-experience",
  },
];

export const IMPACT_STATS = [
  { value: "120K+", label: "Audience reached" },
  { value: "9", label: "Cultural pillars" },
  { value: "300+", label: "Workshops delivered" },
  { value: "48", label: "Artists commissioned" },
];

export const TESTIMONIALS = [
  {
    quote:
      "It felt like walking into a film. My kids talked about it for weeks — they want to be the storytellers now.",
    name: "Amara O.",
    role: "Parent, Level Up programme",
  },
  {
    quote:
      "Temple of Kulture is doing something nobody else in the UK is doing — fusing tech, culture and community without compromise.",
    name: "Dr. K. Mensah",
    role: "Cultural Researcher",
  },
  {
    quote:
      "We booked them for our away day. Our team is still talking about the Afro Brunch projection set.",
    name: "Priya R.",
    role: "Head of People, FinTech Co.",
  },
];

export const PRESS = [
  "The Guardian",
  "Time Out",
  "gal-dem",
  "Resident Advisor",
  "BBC Culture",
  "Dazed",
  "Vice",
  "Black Ballad",
];

export const PARTNERS = [
  "Arts Council England",
  "British Film Institute",
  "UAL Creative Computing",
  "Roundhouse",
  "Somerset House Studios",
  "BFI",
  "Greater London Authority",
];

export const FAQ = [
  {
    q: "Is Temple of Kulture for me?",
    a: "If you love immersive culture, storytelling, gaming, music, XR or community — yes. Our experiences span ages, identities and price points.",
  },
  {
    q: "Are your spaces accessible?",
    a: "We prioritise wheelchair access, relaxed performances, captioning and sensory-aware sessions across our programme. Each event page details specific provisions.",
  },
  {
    q: "Do you offer memberships?",
    a: "TOK Membership launches in 2026 — early access, member-only experiences and Academy discounts. Join the mailing list for first access.",
  },
  {
    q: "Can my organisation work with you?",
    a: "Yes. We design bespoke immersive experiences for brands, teams and cultural institutions. Submit a corporate enquiry to start the conversation.",
  },
];
